import { render, staticRenderFns } from "./ChangeEmailConfirmModule.vue?vue&type=template&id=04f5d6ba&scoped=true&"
var script = {}
import style0 from "./ChangeEmailConfirmModule.vue?vue&type=style&index=0&id=04f5d6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f5d6ba",
  null
  
)

export default component.exports